import { useEffect, useState } from 'react';

/*
 * One shared 1-second ticker per mount site (LiveConsole mounts it once and
 * passes elapsed seconds down), mirroring the prototype's single setInterval.
 * The interval is cleared on unmount.
 */
export const useCountdown = (enabled: boolean): number => {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    const id = window.setInterval(() => setElapsed((e) => e + 1), 1000);
    return () => window.clearInterval(id);
  }, [enabled]);

  return elapsed;
};

/*
 * Countdown copy CLAMPS at zero (never negative, fixtures never act):
 *   remaining > 0  -> "Offers in N min"  (N >= 1)
 *   remaining <= 0 -> "Due now"
 */
export const formatCountdown = (
  secondsRemaining: number,
  elapsed: number,
  purpose: 'offers' | 'look_again' = 'offers',
): string => {
  const remaining = secondsRemaining - elapsed;
  const minutes = Math.max(1, Math.floor(remaining / 60));
  // A waiting activation whose return time has passed is ready, not "due": it looks again on the
  // next tick, and the copy must not promise a future that has already arrived.
  if (purpose === 'look_again') {
    return remaining <= 0
      ? 'Ready to look again'
      : `Looks again in ${minutes} min`;
  }
  if (remaining <= 0) return 'Due now';
  return `Offers in ${minutes} min`;
};
